import { styled } from '@mui/material/styles';
import {
  HEADER_LOGO_DESKTOP_WIDTH,
  HEADER_LOGO_MOBILE_WIDTH,
} from '../headers/Global_DS_Header/constants/headerConstants';

export const StyledFooter = styled('footer')(
  ({ theme }) => `
    background-color: ${theme.DS_palette.background.lightgrey};
    padding: ${theme.DS_spacing(['xs'])};
    padding-bottom: ${theme.DS_spacing(['md'])};
    margin-top: ${theme.DS_spacing(['lgx'])};
    
    ${theme.breakpoints.up('md')} {
      padding: 38px 31px 45px;
    }
    
    ${theme.breakpoints.up('lg')} {
      display: flex;
      justify-content: center;
    }
  `,
);

export const StyledFooterInner = styled('div')(
  ({ theme }) => `
    background-color: ${theme.DS_palette.primary.white};
    padding: ${theme.DS_spacing(['sm'])};
    border-radius: 12px;
    
    ${theme.breakpoints.up('lg')} {
      width: 1096px;
      max-width: 1096px;
      padding: ${theme.DS_spacing(['xl'])} ${theme.DS_spacing(['xxl'])};
    }
  `,
);

export const StyledFooterHeader = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-flow: column nowrap;
    
    ${theme.breakpoints.up('lg')} {
      align-items: center;
      flex-flow: row;
      justify-content: space-between;
    }
  `,
);

export const StyledFooterLogo = styled('div')(
  ({ theme, $isDRSmileInactive }) => `
    padding: 10px;
    display: flex;
    justify-content: center;
    margin-bottom: ${theme.DS_spacing(['md'])};
    
    svg {
       width: ${$isDRSmileInactive ? '90px' : `${HEADER_LOGO_MOBILE_WIDTH}`} ;
       height: ${$isDRSmileInactive ? '20px' : '100%'} ;
    }
    
    ${theme.breakpoints.up('lg')} {
      margin-bottom: 0;
      
      svg {
         width: ${$isDRSmileInactive ? '140px' : `${HEADER_LOGO_DESKTOP_WIDTH}`} ;
      }
    }
  `,
);

export const StyledFooterDivider = styled('div')(
  ({ theme }) => `
    width: 100%;
    height: 2px;
    background-color: ${theme.DS_palette.border.light};
    margin: ${theme.DS_spacing(['xl'])} 0;
 `,
);

export const StyledFooterMenuList = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-flow: column nowrap;
    padding-right: ${theme.DS_spacing(['xl'])};
    
    .MuiAccordion-root {
      box-shadow: none;
      border-bottom: 1px solid ${theme.DS_palette.background.lightgrey};
      
      &:before {
        height: 0;
      }
    }
    
    ${theme.breakpoints.up('md')} {
      padding-right: 0;
    }
    ${theme.breakpoints.up('lg')} {
      flex-flow: row;
      justify-content: space-between;
      align-items: flex-start;
    }
  `,
);

export const StyledFooterSocialMenuList = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-flow: column nowrap;
    padding: ${theme.DS_spacing(['sm'])} 0;
    
    ${theme.breakpoints.up('md')} {
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    ${theme.breakpoints.up('lg')} {
      padding: 0px;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
    }
  `,
);
